import { Module } from "app/modules/models/module";
import { Service } from "app/services/models/service";
import { Button, Col, Icon, Row, Table } from "design-react-kit";
import { ActaAuthContext } from "pa_kit/auth";
import Loading from "pa_kit/components/loading";
import { useContext, useEffect, useState } from "react";
import {  useNavigate, useParams } from "react-router-dom";


import ApiService from 'services/api';


export const ActafoiaModulesListView = (props:any) => {

    const auth = useContext<any>(ActaAuthContext);
    const actagov_config = auth.organization.active_licenses?.services?.actagov;
    const sportellodigitale_config = auth.organization.active_licenses?.services?.sportellodigitale;
        






    const navigate = useNavigate();
    const params = useParams();

    const [ isLoading, _set_isLoading ] = useState(true);
    
    const [ services, _setServices ]                    = useState([]);
    const [ searchDateFrom, _setSearchDateFrom ]        = useState<string|undefined>();
    const [ searchDateTo, _setSearchDateTo ]            = useState<string|undefined>();
    
    const [ isSearchDateFromFocused, toggleSearchDateFromFocus ] = useState(false);
    const toggleSearchDateFromFocusLabel = () => toggleSearchDateFromFocus(true);
    const toggleSearchDateFromBlurLabel = (e:any) => {
        if (e.target.value === '') {
        toggleSearchDateFromFocus(!isSearchDateFromFocused);
        }
    };
    const [ isSearchDateToFocused, toggleSearchDateToFocus ] = useState(false);
    const toggleSearchDateToFocusLabel = () => toggleSearchDateToFocus(true);
    const toggleSearchDateToBlurLabel = (e:any) => {
        if (e.target.value === '') {
        toggleSearchDateToFocus(!isSearchDateToFocused);
        }
    };

    var today = new Date().toISOString().split("T")[0];

    useEffect(() => {
        _set_isLoading(true);
        fetchServices();
    }, []);


    const fetchServices = async () => {
        var responseData = await ApiService.getServices();
        _setServices(responseData.filter((element:Service) => element.modules.find((element:Module) => element.actafoiaEnabled )));
        _set_isLoading(false);
    }

    const exportCsv = (module:Module) => {
        var exportUrl = sportellodigitale_config.backend_url + 'api/modules/' + module.id + '/export_requests?';
        if(searchDateFrom) exportUrl += 'from=' + searchDateFrom + '&';
        if(searchDateTo) exportUrl += 'to=' + searchDateTo + '&';
        console.log('redirecting to:', [exportUrl])
        window.open( exportUrl, '_blank');
    }

    return (
        <div className="admin-card">
            <div className="admin-card-header">
                <div className="admin-card-icon admin-card-icon-news black-gradient">
                    <Icon color='white' icon='it-download' size='lg'/>
                </div>
                <p><small>
                    Esportazione Actafoia
                </small></p>
            </div>
            <hr className="divider-dark mb-4" />
            <div className="admin-card-content px-4">




                {isLoading ? (
                    <div style={{ width: "100%", textAlign: "center" }}><Loading /></div>
                ):(
                    <>
                        <Col>
                            <Row>
                                <Col sm="6" className='form-group flex-grow-1'>
                                    <div className='input-group'>
                                        <label htmlFor='input-group-1' className={searchDateFrom || isSearchDateFromFocused || true ? 'active' : ''}>
                                            Esporta pratiche dal
                                        </label>
                                        <input
                                            type='date'
                                            className={isSearchDateFromFocused || true ? 'form-control focus--mouse' : 'form-control'}
                                            onFocus={toggleSearchDateFromFocusLabel}
                                            onBlur={toggleSearchDateFromBlurLabel}
                                            name="searchDateFrom" id="searchDateFrom"
                                            value={searchDateFrom}
                                            max={searchDateTo ?? today}
                                            onChange={(event) => _setSearchDateFrom(event.target.value)}
                                            
                                        />
                                    </div>
                                </Col>
                                <Col sm="6" className='form-group flex-grow-1'>
                                    <div className='input-group'>
                                        <label htmlFor='input-group-1' className={searchDateTo || isSearchDateToFocused || true ? 'active' : ''}>
                                            Esporta pratiche fino al
                                        </label>
                                        <input
                                            type='date'
                                            className={isSearchDateToFocused || true ? 'form-control focus--mouse' : 'form-control'}
                                            onFocus={toggleSearchDateToFocusLabel}
                                            onBlur={toggleSearchDateToBlurLabel}
                                            name="searchDateTo" id="searchDateTo"
                                            value={searchDateTo}
                                            min={searchDateFrom}
                                            max={today}
                                            onChange={(event) => _setSearchDateTo(event.target.value)}
                                            
                                        />
                                    </div>
                                </Col>
                            </Row>
                            {services.map((service:Service, index:number) => (
                                <Row key={"actafoia_export_service_" + index} className="mb-4">
                                    <h6>{service.name}</h6>
                                    {service.modules.filter((module:Module, index:number) => module.actafoiaEnabled).map((module:Module) => (
                                        <Button className="mb-2" size="sm" key={"actafoia_export_module_" + index} data-element="service-file" color='primary' onClick={()=> exportCsv(module)}>
                                            {!searchDateFrom && !searchDateTo && (
                                                <>Esporta TUTTE le pratiche &quot;{module.name}&quot;</>
                                            )}
                                            {searchDateFrom && !searchDateTo && (
                                                <>Esporta le pratiche &quot;{module.name}&quot; dal {(new Date(searchDateFrom)).toLocaleDateString()}</>
                                            )}
                                            {!searchDateFrom && searchDateTo && (
                                                <>Esporta le pratiche &quot;{module.name}&quot; fino al {(new Date(searchDateTo)).toLocaleDateString()}</>
                                            )}
                                            {searchDateFrom && searchDateTo && (
                                                <>Esporta le pratiche &quot;{module.name}&quot; dal {(new Date(searchDateFrom)).toLocaleDateString()} al {(new Date(searchDateTo)).toLocaleDateString()}</>
                                            )}
                                        </Button>
                                    ))}
                                </Row>
                            ))}
                        </Col>
                    </>
                )}
            </div>
        </div>

    );

}